import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { ConfigProvider } from "antd";
import { store, persistor } from "./redux/store";
import { RouterProvider } from "react-router-dom";
import router from "./components/History/index.component";
import "./index.scss";
import { pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.mjs`;

if (process.env.NODE_ENV === "production") {
  console.log = () => {
    // console.log
  };
  console.warn = () => {
    // console.warn
  };
  console.error = () => {
    // console.error
  };
}
if ("serviceWorker" in navigator)
  navigator.serviceWorker.ready.then(() =>
    navigator.serviceWorker
      .register("/firebase-messaging-sw.js")
      .then((registration) => {
        console.log("Service Worker registered:", registration);
      })
      .catch((err) => {
        console.error("Service Worker registration failed:", err);
      })
  );
ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <ConfigProvider
    theme={{
      token: {
        colorPrimary: "#47AB34",
        controlHeight: 35,
        fontFamily: "'Roboto', sans-serif",
      },
      components: {
        Menu: {
          activeBarHeight: 5,
        },
        Button: {
          fontWeight: 600,
        },
        Typography: {
          fontFamily: "'Roboto', sans-serif",
        },
      },
    }}
  >
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <RouterProvider router={router} />
      </PersistGate>
    </Provider>
  </ConfigProvider>
);
